<div class="video-modal">
  <div class="modal-header">
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="closePopup()"
    ></button>
  </div>
  <div class="modal-body">
    <div class="h-90">
      <iframe [src]="safeUrl" width="100%" height="100%"></iframe>
      <!--<iframe [src]="url" width="100%" height="100%">
    <p>Your browser does not support iframes.</p>
  </iframe>-->
    </div>
  </div>
</div>
